import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { VideoModal } from "app/components/common";
import normalize from "app/utils/normalize";
import normalizeSource from "app/utils/normalizeSource";
import React from "react";
import { Dimensions, StyleSheet } from "react-native";
import { BUBBLE_WIDTH } from "./constants";
import { IMessage } from "@microdoing/shared/services/message/types";

const { width } = Dimensions.get("window");

const minBubbleHeight = normalize(150);

const styles = StyleSheet.create({
  messageBubbleChat: {
    backgroundColor: "white",
    width: BUBBLE_WIDTH,
    borderRadius: 8,
    marginTop: 5,
    marginRight: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  messageImage: {
    backgroundColor: "white",
    height: minBubbleHeight,
    width: BUBBLE_WIDTH,
    borderRadius: 8,
    margin: 0,
    marginRight: 0,
  },
});

interface Props {
  currentMessage?: (IMessage & { uri?: string }) | undefined;
}

const VideoMessage = ({
  currentMessage = {
    video: "",
    uri: "",
    image: "",
    _id: "",
    text: "",
    createdAt: "",
    user: {},
  },
}: Props) => {
  const { video = "", uri, image = "" } = currentMessage;

  if (currentMessage?.video) {
    return (
      <VideoModal
        imagePreviewStyle={{
          backgroundColor: "white",
          width: BUBBLE_WIDTH,
          borderRadius: 8,
          margin: 0,
          marginRight: 0,
          borderBottomLeftRadius: !!currentMessage?.text ? 3 : 0,
          borderBottomRightRadius: !!currentMessage?.text ? 3 : 0,
        }}
        style={{
          backgroundColor: "white",
          width: BUBBLE_WIDTH,
          height: minBubbleHeight,
          borderRadius: 8,
          marginRight: 0,
          margin: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        maxHeight={isWebDesktop ? 250 : null}
        commentaryWidth={BUBBLE_WIDTH}
        source={{ uri: video }}
        fileUrl={video}
        imagePreview={normalizeSource(image)}
        video={video}
      />
    );
  }
  return null;
};

export default VideoMessage;
